export enum OperationType {
    RECEIPT = 1,
    EXPENSE = 2,
    POSTING = 3,
    DEDUCT = 4,
    MISGRADING = 5,
}
